// extracted by mini-css-extract-plugin
export default {"card":"HomeCard_card__vrtdj","content":"HomeCard_content__D17rb","image":"HomeCard_image__Ei-DH","overlay":"HomeCard_overlay__tstXI","text":"HomeCard_text__rN6ET"};